import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bvzjvsphbw: FaireBrandEntity = {
  token: "b_bvzjvsphbw",
  type: "brand",
  name: "Devil Daves Bloody Mary Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/211303e406dc7c0c94eea67176a858132367b4e726bcf7e18557c28ab47f96dc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8aff56b9ae239f4dea75d1471df79203adfc47002d40db4e4935cb97c53d2d4b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/211303e406dc7c0c94eea67176a858132367b4e726bcf7e18557c28ab47f96dc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8aff56b9ae239f4dea75d1471df79203adfc47002d40db4e4935cb97c53d2d4b.jpeg",
  location: "Rehoboth Beach, DE, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 42,
  isInsider: true,
  description:
    "Devil Daves delivers a complete Bloody Mary experience from seasoning to pour. Our family of award-winning products is crafted for consistency, convenience, and flavor that never misses. From our legendary Bloody Mary Seasoning Stick Packs to our new Ready-to-Pour Bloody Mary Pouch Mixer, every blend is chef-created and perfectly balanced. Customers can make their ideal Bloody using any tomato juice or pour it straight from the pouch—no guesswork, no waste.\n\nOur Rim Salts, including Chili Lime and Burn Bacon, add bold flair to every glass, while Pickle Crack Hot Sauce brings briny pickle perfection with cayenne heat to burgers, sandwiches, and of course, Bloody Marys. Whether it’s brunch, camping, tailgates, or gift baskets, Devil Daves products fit seamlessly into every occasion.\n\nWe’re proud to be the first Bloody Mary brand in a stick pack, expanding the category with portable, shelf-stable mixes that work anywhere. With proven sell-through at retailers nationwide and gold-medal wins at events like the Rochester and NYC Bloody Mary Fests plus multiple Drunken Tomato Awards, Devil Daves is a proven crowd favorite.\n\nStock your shelves with flavor that moves. Sign up for Faire Insider Shipping for fast, free delivery and access to wholesale perks:\n✅ https://www.faire.com/retailer/settings/insider-membership",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:21.992Z",
    importedBy: "entity-db-cli",
  },
};
